module.exports = __webpack_public_path__ + "img/aqy.34959da7.png";